import useFetch from './fetch';

export default function useGetCategoryKeys() {
  const fetch = useFetch();
  return (categoryId) => { return fetch(`/api/categories/${categoryId}/keys`).then(x => x.json()) };
};
